import React, { Fragment} from 'react';
import {WifiCalling3} from '@mui/icons-material';
import { ACSContext } from '../../contexts/ACSContext';

const AcsStatus = () => {
  const {callAgent} = React.useContext(ACSContext);

  return (
    <Fragment>
      {!!callAgent ? <WifiCalling3 style={{color: 'green', transform: 'scale(0.7)'}}/> : <WifiCalling3 style={{color: 'red', transform: 'scale(0.7)'}}/>}
    </Fragment>
  );
};

export default AcsStatus;